import { render, staticRenderFns } from "./referee-layout.vue?vue&type=template&id=2c28d471&scoped=true"
import script from "./referee-layout.vue?vue&type=script&lang=js"
export * from "./referee-layout.vue?vue&type=script&lang=js"
import style0 from "./referee-layout.vue?vue&type=style&index=0&id=2c28d471&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c28d471",
  null
  
)

export default component.exports